module.exports = __webpack_public_path__ + "static/media/Lioness-4.3ae380f2.jpg";